<template>
  <div>
    <div class="dashboard-chart-row flex flex-wrap">
      <div class="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
        <card-line-chart />
      </div>
      <div class="w-full xl:w-4/12 px-4">
        <card-bar-chart />
      </div>
    </div>
    <div class="dashboard-chart-row flex flex-wrap mt-4">
      <div class="w-full xl:w-6/12 mb-12 xl:mb-0 px-4">
        <card-avg-time-chart />
      </div>
      <div class="w-full xl:w-6/12 px-4">
        <card-funnel-chart />
      </div>
    </div>
    <div class="dashboard-chart-row flex flex-wrap mt-4">
      <div class="w-full px-4">
        <card-scene-entry-chart />
      </div>
    </div>
    <div class="dashboard-chart-row flex flex-wrap mt-4">
      <div class="w-full px-4">
        <card-activity-progress-subscription-chart />
      </div>
    </div>
    <div class="dashboard-chart-row flex flex-wrap mt-4">
      <div class="w-full px-4">
        <card-daily-welfare-subscription-chart />
      </div>
    </div>
  </div>
</template>
<script>
import CardLineChart from "@/components/Cards/CardLineChart.vue";
import CardBarChart from "@/components/Cards/CardBarChart.vue";
import CardAvgTimeChart from "@/components/Cards/CardAvgTimeChart.vue";
import CardFunnelChart from "@/components/Cards/CardFunnelChart.vue";
import CardSceneEntryChart from "@/components/Cards/CardSceneEntryChart.vue";
import CardActivityProgressSubscriptionChart from "@/components/Cards/CardActivityProgressSubscriptionChart.vue";
import CardDailyWelfareSubscriptionChart from "@/components/Cards/CardDailyWelfareSubscriptionChart.vue";
export default {
  name: "dashboard-page",
  components: {
    CardLineChart,
    CardBarChart,
    CardAvgTimeChart,
    CardFunnelChart,
    CardSceneEntryChart,
    CardActivityProgressSubscriptionChart,
    CardDailyWelfareSubscriptionChart,
  },
};
</script>

<style scoped>
.dashboard-chart-row {
  row-gap: 24px;
}

@media (min-width: 1280px) {
  .dashboard-chart-row {
    column-gap: 24px;
  }

  .dashboard-chart-row > div {
    padding-left: 0;
    padding-right: 0;
  }

  .dashboard-chart-row > .xl\:w-8\/12 {
    width: calc(66.666667% - 12px);
  }

  .dashboard-chart-row > .xl\:w-4\/12 {
    width: calc(33.333333% - 12px);
  }

  .dashboard-chart-row > .xl\:w-6\/12 {
    width: calc(50% - 12px);
  }

  .dashboard-chart-row > .w-full:not(.xl\:w-8\/12):not(.xl\:w-4\/12):not(.xl\:w-6\/12) {
    width: 100%;
  }
}
</style>
